module.exports = __webpack_public_path__ + "static/media/1.d1b0f2e9.png";